import * as React from 'react';
import { Avatar, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import MenuIcon from '@mui/icons-material/Menu';
import ProfileSection from "./ProfileSection";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from '../../../data/config/authConfig';
import AuthService from '../../../data/services/auth-service';
import  '../../../index.css'; 
import {UserPermission} from '../../../views/userPermission';
import { getDashboardMetrics } from '../../../views/pending-claims/data-access';
import { formatCurrency } from '../../../views/pending-claims/commonsUtility';
import { GetUserRole } from '../../../util/userRole';
import { roleCapabilitiesConfig } from '../../../util/role-config';
import { UserRoles } from '../../../util/constants/common.constants';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CustomTooltip from '../../../views/tooltip/custom-tooltip';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  headerAvtar: {
    ...theme.typography.commonAvatar,
    ...theme.typography.mediumAvatar,
    transition: "all .2s ease-in-out",
    background: theme.palette.primary.light,
    color: theme.palette.purple.dark,
    "&:hover": {
      background: theme.palette.purple.main,
      color: theme.palette.purple.light
    }
  },
  boxContainer: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      width: "auto"
    }
    
  },
  envContainer: {
    width: "428px",
    textAlign: "center",
    color : "#d14d4d",
    [theme.breakpoints.down("md")]: {
      width: "auto"
    }
    
  }
}));
export const onSignHandler = (isAuthenticated: boolean, instance: any) => {
  if (isAuthenticated) {
    instance
      .logoutPopup()
      .then(() => localStorage.removeItem("accessToken"))
      .catch((e: any) => {
        console.error(e);
      });
  } else {
    instance
      .loginPopup(loginRequest)
      .then(() => AuthService.refreshAccessToken())
      .catch((e: any) => {
        console.error(e);
      });
  }
};

interface HeaderProps {
    handleLeftDrawerToggle: (event: React.MouseEvent)=>void
}
const Header = (props: HeaderProps) => {
  const { handleLeftDrawerToggle } = props;
  const classes = useStyles();
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  let nonProdEnv = process.env.REACT_APP_IS_PROD?.toString() !== "Y" ? "NON-PRODUCTION ENVIRONMENT" : "";
  const [writeOffMetric, setWriteOffMetric] = React.useState<any>()

  const authHandle = () => {
    onSignHandler(isAuthenticated, instance)
  }

  React.useEffect(() => {
    const fetchWriteOffAmount = async () => {
      try {   
        let userRole = localStorage.getItem("userRole")
        if(userRole === "" || userRole === null || typeof userRole === 'undefined') {
          userRole = await GetUserRole(accounts);
        }       
        const roleConfig = roleCapabilitiesConfig.find(cfg => cfg.role === userRole as UserRoles);
        const roleId = roleConfig?.roleid || 1;   
        const params = {role : roleId, isGlobalMetric: true}
        const res = await getDashboardMetrics(params)
        if(res.status === 200) {
          console.log(res?.data)           
          setWriteOffMetric({
            MetricName: "Writeoffs YTD: " + formatCurrency(res?.data), 
            MetricValue: res?.data
          })                                  
        }
          
      } catch (err) {
        console.log(err?.message);
      }  
    }
    fetchWriteOffAmount();
  }, []);
    

  return (
    isAuthenticated ? 
    <React.Fragment>
      <div className={classes.boxContainer}>     
          <h3 style={{padding : "0px 10px 0px 10px"}}>Clinical Correction Tool</h3>
        <div className={classes.grow} />        
      </div>
      <div className={classes.envContainer}>
        <h3 style={{padding : "0px 10px 0px 10px"}}> {nonProdEnv}</h3>
      </div>
      <div className={classes.grow}> 

      <Typography variant="h4" align="left">
        {writeOffMetric?.MetricName} <CustomTooltip displatText="This dollar amount represents the claims that are written off due to the inability to file the claim. This is commonly due to lack of response from the Doctor or GM, the claim is past the timely filing window and/or insufficient information provided within 3 attempts."></CustomTooltip>
        {typeof writeOffMetric?.MetricValue === 'number' && !isNaN(writeOffMetric?.MetricValue)
          ? ` ${formatCurrency(writeOffMetric?.MetricValue)}`
          : ''}
      </Typography>
      </div>
      <div className={classes.grow} />
       {
         nonProdEnv !== "" ? <UserPermission user={accounts[0]} ></UserPermission> : <></>
       }
       <ButtonBase
          sx={{ borderRadius: "12px", marginRight: "16px" }}
          component="a"
          href={`mailto:clinicalcorrections@myeyedr.com?subject=Clinical Correction Tool Contact Us&body=Hi,%0D%0A%0D%0A`}
          title="Contact Us"
        >
          <MailOutlineIcon style={{ marginRight: 4 }} />
          <Typography variant="body1">Contact Us</Typography>
        </ButtonBase>
      <ProfileSection user={accounts[0]} onSignOut={authHandle}/>
      
    </React.Fragment> : null
  );
};
export default Header;
